var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLinkSimple = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15L15 9",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.13499L13.3181 4.32249C14.1644 3.48992 15.3053 3.02548 16.4924 3.03031C17.6795 3.03514 18.8166 3.50887 19.6561 4.34829C20.4955 5.18772 20.9692 6.32483 20.974 7.51195C20.9789 8.69907 20.5144 9.84 19.6819 10.6862L16.8638 13.4997",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13532 10.5L4.32282 13.3181C3.49026 14.1644 3.02581 15.3053 3.03065 16.4924C3.03548 17.6795 3.5092 18.8166 4.34863 19.6561C5.18805 20.4955 6.32517 20.9692 7.51229 20.974C8.6994 20.9789 9.84034 20.5144 10.6866 19.6819L13.5 16.8638",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkSimple, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LinkSimple.4700ad62.svg";
export { ForwardRef as ReactComponent };